
(() => {
  const LIMIT = 5;               
  const PER_ITEM = 10;           

  const CARD = '[data-product-card]';
  const cache = new Map();       
  let token = 0;                 

  function recosFor(baseUrl, productId, selector) {
    const key = `${baseUrl}|${productId}`;
    if (cache.has(key)) return cache.get(key);
    const url = `${baseUrl}&product_id=${encodeURIComponent(productId)}&limit=${PER_ITEM}`;
    const p = fetch(url)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html) return [];
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return [...doc.querySelectorAll(selector)];
      })
      .catch(() => []);
    cache.set(key, p);
    return p;
  }

  const hide = (el) => { el.classList.add('hide'); el.hidden = true; };
  const show = (el) => { el.classList.remove('hide'); el.hidden = false; };

  function merge(groups, inCart, limit) {
    const seen = new Set();
    const pool = [];
    for (const cards of groups) {
      for (const card of cards) {
        const handle = card.dataset.handle;

        if (!handle || seen.has(handle) || inCart.has(handle)) continue;
        seen.add(handle);
        pool.push(card);
      }
    }
    pool.sort((a, b) => (Number(a.dataset.price) || 0) - (Number(b.dataset.price) || 0));
    return pool.slice(0, limit);
  }

  async function render(cart) {

    const boxes = [...document.querySelectorAll('[data-cart-reco]')].filter((b) => b.dataset.url);
    if (!boxes.length) return;

    const items = cart?.items || [];
    if (!items.length) {
      document.querySelectorAll('[data-cart-reco]').forEach(hide);
      return;
    }

    const inCart = new Set(items.map((i) => i.handle).filter(Boolean));
    const ids = [...new Set(items.map((i) => i.product_id).filter(Boolean))];

    const mine = ++token;
    await Promise.all(boxes.map(async (box) => {
      const selector = box.dataset.cardSelector || CARD;
      const limit = Number(box.dataset.limit) || LIMIT;
      const groups = await Promise.all(ids.map((id) => recosFor(box.dataset.url, id, selector)));
      if (mine !== token) return;             

      const slot = box.querySelector('[data-cart-reco-items]');
      if (!slot) return;
      const chosen = merge(groups, inCart, limit);
      if (!chosen.length) { hide(box); slot.replaceChildren(); return; }

      slot.replaceChildren(...chosen.map((c) => c.cloneNode(true)));
      show(box);

      window.Wishlist?.sync();

      slot.closest('embla-slider')?.embla?.reInit();
    }));
  }

  async function refresh(payload) {
    try {

      const cart = payload?.cart
        || (window.CartAPI ? await window.CartAPI.get()
                           : await fetch('/cart.js').then((r) => r.json()));
      await render(cart);
    } catch (e) {  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh());
  } else {
    refresh();
  }

  window.PubSub?.subscribe(window.EVENTS?.cartUpdate, (payload) => refresh(payload));

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-attention-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const id = Number(btn.dataset.variant);
    if (!id) return;
    btn.disabled = true;
    try {
      await window.CartAPI.add([{ id, quantity: 1 }], { source: 'cross-sell' });
    } catch (err) {
      console.error('[cross-sell] add', err);
    } finally {
      btn.disabled = false;
    }
  });
})();
